import { render, staticRenderFns } from "./PlusClinicSettings.vue?vue&type=template&id=5f2f5354"
import script from "./PlusClinicSettings.vue?vue&type=script&lang=js"
export * from "./PlusClinicSettings.vue?vue&type=script&lang=js"
import style0 from "./PlusClinicSettings.vue?vue&type=style&index=0&id=5f2f5354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports